import React, { useEffect, useState } from 'react';
import Slider from 'react-slick';
import PromotionService from '../promotion/PromotionService';
import ImageService from '../images/imageService.js';
import SearchBar from '../SearchBar/SearchBar';
import styles from './homepage.module.css';

const promotionService = new PromotionService();

function NewUPThomepage() {
  const [promotions, setPromotions] = useState([]);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userRole, setUserRole] = useState('');

  useEffect(() => {
    const token = localStorage.getItem('jwt');
    const role = localStorage.getItem('role');
    if (token) {
      setIsLoggedIn(true);
      setUserRole(role);
    }

    async function fetchPromotions() {
      try {
        const res = await promotionService.getAll();
        const sorted = Array.isArray(res) ? res.sort((a, b) => a.status - b.status) : [];
        setPromotions(sorted);
      } catch (err) {
        console.error("Failed to load promotions:", err);
        setPromotions([]);
      }
    }

    fetchPromotions();
  }, []);

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 6000,
    arrows: true,
    pauseOnHover: true,
  };

  return (
    <div className={styles.pageWrapper}>
      {promotions.length > 0 ? (
        <section className={styles.heroSection}>
          <Slider {...sliderSettings} className={styles.slider}>
           {promotions.map((promo, index) => {
  console.log('PROMO:', promo); // Add this
  return (
    <div key={index} className={styles.slide}>
      <img
        src={ImageService.getImageUrl('promotion', promo.picture)}
        alt={`Promotion ${index + 1}`}
        className={styles.heroImage}
      />
      <div className={styles.overlayText}>
        <h2>{promo.title}</h2>
        <p>{promo.description}</p>
      </div>
    </div>
  );
})}
          </Slider>
        </section>
      ) : (
        <section className={styles.heroSectionEmptyBlack}>
          <div className={styles.noPromoText}>No Active Promotions</div>
        </section>
      )}

      {isLoggedIn && <SearchBar role={userRole} />}

      <section className={styles.infoStackSection}>
        <div className={styles.infoCard}>
          <h3>What Makes New U Physical Therapy Unique</h3>
          <p>
            New U Physical Therapy has been established with the goal of making our patient’s feel relaxed from their busy schedules and get the best-in-class treatment in our Staten Island, NY & Central NJ offices. We are a team of expert physical therapists who work diligently to serve our treated patient’s with superior Physical Therapy Practices. We have a highly respected and qualified team of Physical Therapists in our Staten Island, NY & Central NJ offices who are ready to relieve your daily struggles that only therapy can help.
          </p>
        </div>

        <div className={styles.infoCard}>
          <h3>Orthopedic Rehab Treatment NJ & NY</h3>
          <p>
            A physical therapist’s office is the best place to treat numerous types of physical injuries and conditions affecting your muscles, bones, ligaments and tendons. Here at New U Physical Therapy at our Staten Island, NY and Central NJ office locations, we evaluate and assess what we think will be the best orthopedic rehab treatments needed to get you back in good health and condition. Our therapies include a variety of options such as restoring your strength, improving functional skills, detailed targeted programs and more! Contact New U Physical Therapy for your orthopedic rehab treatments- the best on Staten Island and Central NJ!
          </p>
        </div>

        <div className={styles.infoCard}>
          <h3>NEW U PHYSICAL THERAPY STATEN ISLAND, NY</h3>
          <p>
            Physical therapy is a type of treatment you may need when health problems make it hard to move around and to perform everyday tasks. It helps you move better and relieves pain. It also improves or restores your physical function and fitness level. The goal of physical therapy is to make daily tasks and activities easier. For example, it may help with walking, going up stairs, or getting in and out of bed, and improving work related activities.
          </p>
        </div>
      </section>
      <section className={styles.additionalSection}>
  <h2>Physical Therapy Treatment Central<br/>New Jersey & Staten Island, NY</h2>
  <p>
    Our efforts to strive and relieve patient’s from their physical pains continues to be our utmost goal. There may be innumerable facts that will lead someone to opt for Physical Therapy Treatment and for this purpose we employ some of the top therapists in the Staten Island, NY & Edison, New Brunswick, Old Bridge and Central New Jersey area.
  </p>
  <p>
    There are various services that comprise our Physical Therapy offerings and a few of them are Massage therapy, Acupuncture, Pressotherapy, Cold Laser, and Chiropractic. If you’re experiencing pain, loss of function or discomfort and are looking for relief from it, you can always seek support from our therapists, as we are trained therapy and rehabilitation experts.
  </p>
  <p>
    Be it neck pain or back pain, due to prolonged working hours, or a pain in your hands and legs because you picked something that was too heavy for you; just reach out to the clinic of New U Physical Therapy for getting the best treatment in physical therapy in the Central NJ area and be rest assured you will restore function and regain health.
  </p>
  
</section>

    </div>
  );
}

export default NewUPThomepage;
